import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import EshopWizard from '../components/eshop-wizard/EshopWizard';

function EshopWizardPage() {
    const navigate = useNavigate();
    const { eshopId } = useParams();
    const [eshopName, setEshopName] = useState('');

    const handleComplete = (eshop) => {
        navigate('/eshops');
    };

    const handleCancel = () => {
        navigate('/eshops');
    };

    const handleEshopNameChange = (name) => {
        setEshopName(name);
    };

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h4" gutterBottom>
                    {eshopId ? `Edit E-shop${eshopName ? ` - ${eshopName}` : ''}` : 'Add New E-shop'}
                </Typography>
                <Button
                    startIcon={<BackIcon />}
                    onClick={handleCancel}
                    variant="contained"
                >
                    Back to E-shops
                </Button>
            </Box>

            <EshopWizard
                onComplete={handleComplete}
                eshopId={eshopId ? parseInt(eshopId) : null}
                eshopIdParam={eshopId}
                onEshopNameChange={handleEshopNameChange}
            />
        </Box>
    );
}

export default EshopWizardPage;